import { Oval } from "react-loader-spinner";

function DataLoader() {
    return (
        <div className="data-loader">
            <Oval
                visible={true}
                height="40"
                width="40"
                strokeWidth="5"
                ariaLabel="oval-loading"
                wrapperClass="discuss-wrapper"
                color="#23b4c3"
                secondaryColor="#dadada" // background stroke (default is green)
            />
        </div>
    );
}

export default DataLoader;